import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AppointmentService } from "../api";

export const actionCreateBooking = createAsyncThunk(
  "order/create-booking",
  async (data, { rejectWithValue }) => {
    try {
      // debugger;
      const res = await AppointmentService.doCreateBooking(data);

      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCheckQuery = createAsyncThunk(
  "order/check-query",
  async (data) => {
    try {
      const res = await AppointmentService.doCheckQuery(data);

      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast(res.data.message);
        return res.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return message;
    }
  }
);

export const actionGetHistoryBookingDoctor = createAsyncThunk(
  "order/history-booking-doctor",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AppointmentService.doGetHistoryBookingDoctor(data);

      if (res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetHistoryBookingUser = createAsyncThunk(
  "order/history-booking-user",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AppointmentService.doGetHistoryBookingUser(data);

      if (res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionCancelBookingUser = createAsyncThunk(
  "order/cancel-booking-user",
  async (data, { rejectWithValue }) => {
    try {
      const res = await AppointmentService.doCancelBookingUser(data);

      if (res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const appointmentSlice = createSlice({
  name: "appointment",
  initialState: {
    createBooking: {
      loading: false,
      data: null,
      error: "",
    },
    historyBookingDoctor: {
      loading: false,
      data: null,
      error: "",
    },
    historyBookingUser: {
      loading: false,
      data: null,
      error: "",
    },
    cancelBookingUser: {
      loading: false,
      data: null,
      error: "",
    },
    checkQuery: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // createBooking
      .addCase(actionCreateBooking.pending, (state) => {
        state.createBooking.loading = true;
      })
      .addCase(actionCreateBooking.fulfilled, (state, action) => {
        state.createBooking.loading = false;
        state.createBooking.data = action.payload;
      })
      .addCase(actionCreateBooking.rejected, (state, action) => {
        state.createBooking.loading = false;
        state.createBooking.data = action.payload;
        state.createBooking.error =
          action.error.message || "Something went wrong";
      })

      // checkQuery
      .addCase(actionCheckQuery.pending, (state) => {
        state.checkQuery.loading = true;
      })
      .addCase(actionCheckQuery.fulfilled, (state, action) => {
        state.checkQuery.loading = false;
        state.checkQuery.data = action.payload;
        state.checkQuery.data = {};
      })
      .addCase(actionCheckQuery.rejected, (state, action) => {
        state.checkQuery.loading = false;
        state.checkQuery.data = action.payload;
        state.checkQuery.error = action.error.message || "Something went wrong";
      })

      // history Booking Doctor
      .addCase(actionGetHistoryBookingDoctor.pending, (state) => {
        state.historyBookingDoctor.loading = true;
      })
      .addCase(actionGetHistoryBookingDoctor.fulfilled, (state, action) => {
        state.historyBookingDoctor.loading = false;
        state.historyBookingDoctor.data = action.payload;
      })
      .addCase(actionGetHistoryBookingDoctor.rejected, (state, action) => {
        state.historyBookingDoctor.loading = false;
        state.historyBookingDoctor.data = action.payload;
        state.historyBookingDoctor.error =
          action.error.message || "Something went wrong";
      })

      // history Booking User
      .addCase(actionGetHistoryBookingUser.pending, (state) => {
        state.historyBookingUser.loading = true;
      })
      .addCase(actionGetHistoryBookingUser.fulfilled, (state, action) => {
        state.historyBookingUser.loading = false;
        state.historyBookingUser.data = action.payload;
      })
      .addCase(actionGetHistoryBookingUser.rejected, (state, action) => {
        state.historyBookingUser.loading = false;
        state.historyBookingUser.data = action.payload;
        state.historyBookingUser.error =
          action.error.message || "Something went wrong";
      })

      // cancelBookingUser
      .addCase(actionCancelBookingUser.pending, (state) => {
        state.cancelBookingUser.loading = true;
      })
      .addCase(actionCancelBookingUser.fulfilled, (state, action) => {
        state.cancelBookingUser.loading = false;
        state.cancelBookingUser.data = action.payload;
      })
      .addCase(actionCancelBookingUser.rejected, (state, action) => {
        state.cancelBookingUser.loading = false;
        state.cancelBookingUser.data = action.payload;
        state.cancelBookingUser.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default appointmentSlice.reducer;
export const { actions, reducer } = appointmentSlice;
